<div class="blog-page">
  <!-- Hero section with Blauwtand background image -->
  <section class="blog-hero">
    <app-breadcrumbs></app-breadcrumbs>
    <div class="blog-hero__container">
      <div class="blog-hero__content">
        <div class="hero-copy">
          <h1 class="hero-title">Stories</h1>
          <p class="hero-subtitle">
            Ontdek de laatste trends, praktische tips en inspirerende verhalen over professionals, carrière en de arbeidsmarkt.
          </p>
        </div>
        <div class="blog-search-box">
          <label class="search-field" aria-label="Zoek in blogartikelen">
            <icon name="search" class="search-icon"></icon>
            <input
              type="search"
              [formControl]="searchControl"
              class="search-input"
              placeholder="Zoeken"
              autocomplete="off"
              />
          </label>
          @if (categories.length > 0) {
            <div class="category-filters">
              <button
                type="button"
                class="chip"
                [class.chip--active]="!activeCategory"
                (click)="onSelectCategory(null)"
                aria-label="Toon alle artikelen"
                >
                Alle artikelen
              </button>
              @for (category of categories; track category) {
                <button
                  type="button"
                  class="chip"
                  [class.chip--active]="activeCategory === category.slug"
                  (click)="onSelectCategory(category)"
                  [attr.aria-label]="'Filter op ' + category.name"
                  >
                  {{ category.name }}
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Decorative hero orbs -->
    <svg class="hero-orb orb-a" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id="blogOrbGradientA" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6"/>
          <stop offset="100%" stop-color="#75b6e7" stop-opacity="0"/>
        </radialGradient>
      </defs>
      <circle cx="200" cy="200" r="200" fill="url(#blogOrbGradientA)"/>
    </svg>
    <svg class="hero-orb orb-b" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id="blogOrbGradientB" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35"/>
          <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
        </radialGradient>
      </defs>
      <circle cx="200" cy="200" r="200" fill="url(#blogOrbGradientB)"/>
    </svg>

    <!-- Wave separator -->
    <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#f6f6f6"></path>
    </svg>
  </section>

  <!-- Blog list container -->
  <div class="blog-content-container">
    <div class="blog-content">
      <!-- Skeleton Loading State -->
      @if (isLoading && !blogs.length) {
        <div class="blog-grid">
          @for (_ of [1,2,3,4,5,6]; track _) {
            <div class="blog-card-skeleton">
              <div class="skeleton skeleton-image"></div>
              <div class="skeleton-body">
                <div class="skeleton skeleton-chip"></div>
                <div class="skeleton skeleton-title"></div>
                <div class="skeleton skeleton-title-short"></div>
                <div class="skeleton skeleton-excerpt"></div>
                <div class="skeleton skeleton-excerpt"></div>
                <div class="skeleton skeleton-excerpt-short"></div>
                <div class="skeleton-meta">
                  <div class="skeleton skeleton-date"></div>
                  <div class="skeleton skeleton-cta"></div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Blog Grid -->
      @if (!isLoading && blogs.length) {
        <div class="blog-grid">
          @for (item of blogs; track trackBySlug($index, item)) {
            <app-blog-card
              [item]="item"
            ></app-blog-card>
          }
        </div>
      }

      <!-- Empty State -->
      @if (!isLoading && !blogs.length && !errorMessage) {
        <div class="blog-empty">
          <div class="empty-illustration">
            <icon name="search" class="empty-icon"></icon>
          </div>
          <h3 class="empty-title">Geen artikelen gevonden</h3>
          <p class="empty-message">Probeer een andere zoekopdracht of selecteer een andere categorie.</p>
        </div>
      }

      <!-- Error State -->
      @if (errorMessage) {
        <div class="blog-error">
          <div class="error-illustration">
            <icon name="error" class="error-icon"></icon>
          </div>
          <h3 class="error-title">Er ging iets mis</h3>
          <p class="error-message">{{ errorMessage }}</p>
          <button type="button" class="apple-cta apple-cta--blue" (click)="retry()">
            <span>Probeer opnieuw</span>
            <icon name="refresh"></icon>
          </button>
        </div>
      }

      <!-- Load More Button -->
      @if (blogs.length && hasMore) {
        <div class="blog-load-more">
          <button
            type="button"
            class="apple-cta apple-cta--blue"
            [disabled]="isLoadingMore"
            (click)="onLoadMore()"
            >
            @if (!isLoadingMore) {
              <span>Meer artikelen laden</span>
              <icon name="expand_more"></icon>
            } @else {
              <span class="loading-inline"></span>
              <span>Laden...</span>
            }
          </button>
        </div>
      }

      <div #loadMoreSentinel class="sentinel" aria-hidden="true"></div>
    </div>
  </div>
</div>
